// ANGULAR
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { OraculoAPIUser, PostLoginRequest, M2MOraculoAPIUser, TokenData, Methods, PostVerifyAuthRequest, PostM2MLoginRequest, PostTokenRefreshRequest } from '@models/auth.model';
// RXJS
import { Observable, of } from 'rxjs';
// OTHERS
import { Paths } from '@constants/paths.const';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient,
    private router: Router
  ) { }

  postM2MLogin(): Observable<M2MOraculoAPIUser> {
    const credentialsUser: PostM2MLoginRequest = { nombre: 'oraculo', password: '1'};
    const credentialsAdmin: PostM2MLoginRequest = { nombre: 'oraculo admin', password: '1'};

    return this.http.post<M2MOraculoAPIUser>(`${this.globalService.apiUrl.url}/Auth/M2MLogin`, credentialsAdmin);
  }

  postLogin(postLoginRequest: PostLoginRequest): Observable<OraculoAPIUser> {
    return this.http.post<OraculoAPIUser>(`${this.globalService.apiUrl.url}/Auth/UserLogin`, postLoginRequest, this.httpOptions);
  }

  postLogout(): Observable<void> {
    if (!!this.globalService.token) {
      return this.http.post<void>(`${this.globalService.apiUrl.url}/Auth/UserLogout`, null, this.httpOptions);
    } else {
      //Si no hay token almacenado por el motivo que sea no hacemos petición al servidor
      this.router.navigateByUrl(Paths.login);
      return of();
    }
  }

  postRefreshToken(): Observable<TokenData> {
    const postTokenRefreshRequest: PostTokenRefreshRequest = { accessToken: this.globalService.token ?? '', refreshToken: this.globalService.refreshToken ?? ''};

    return this.http.post<TokenData>(`${this.globalService.apiUrl.url}/Auth/TokenRefresh`, postTokenRefreshRequest, this.httpOptions);
  }

  postGetMethods(method: string): Observable<Methods> {
    return this.http.post<Methods>(`${this.globalService.apiUrl.url}/Auth/Methods/${method}`, null, this.httpOptions);
  }

  postVerifyMethod(postVerifyAuthRequest: PostVerifyAuthRequest): Observable<OraculoAPIUser> {
    const method: string = "Totp";

    return this.http.post<OraculoAPIUser>(`${this.globalService.apiUrl.url}/Auth/Methods/${method}/Verify`, postVerifyAuthRequest, this.httpOptions);
  }
}